module.exports = __webpack_public_path__ + "img/ad-cp.7ad7025b.png";